import React, { useState, useEffect } from 'react';
import FileUpload from 'components/Common/FileUpload';

import { getStorageSetting } from 'actions';

import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

const UploadWhsDocuments = ({ setDisableConfirm, onSubmit, isSubmitting }) => {
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [uploadsInProgress, setUploadsInProgress] = useState(0);
  const files = getStorageSetting('files') || [];
  const maxWhsFileSize = useSelector(state => (
    state.auth.settings && state.auth.settings.files
      ? state.auth.settings.files.maxWhsFileSize
      : null
  ));
  const uploadChunkSize = useSelector(state => (
    state.auth.settings && state.auth.settings.files
      ? state.auth.settings.files.uploadChunkSize
      : null
  ));

  useEffect(() => {
    const shouldDisable = uploadedDocs.length === 0 || uploadsInProgress > 0;
    setDisableConfirm(shouldDisable);
  }, [uploadedDocs, uploadsInProgress, setDisableConfirm]);

  const onFileUploadCancel = (file) => {
    toastr.info('', `Upload of ${ file.name } has been canceled`);
    setUploadsInProgress(prev => (prev > 0 ? prev - 1 : 0));
  };

  const onFileUploadError = (file, error) => {
    toastr.error('', `Upload of ${ file.name } has been canceled.  ${ error.message }`);
    setUploadsInProgress(prev => (prev > 0 ? prev - 1 : 0));
  };

  const onFileUploadSuccess = (file, response) => {
    const joinedArray = uploadedDocs.concat(response);
    setUploadedDocs(joinedArray);
    toastr.success('', `${ response[0].fileName } has been uploaded`);
    setUploadsInProgress(prev => (prev > 0 ? prev - 1 : 0));
  };

  const onFileSending = () => {
    setUploadsInProgress(prev => prev + 1);
  };

  const onDeleteUploadedDocument = (file) => {
    ApiService
      .deleteTempUpload(file.id)
      .then((result) => {
        if (result != null) {
          const newUploadedDocs = uploadedDocs.filter(doc => doc.id !== file.id);
          setUploadedDocs(newUploadedDocs);
        } else {
          toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
        }
      })
      .catch(err => toastr.error('', `Failed to remove ${ file.name }.  Please try again`));
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    onSubmit(uploadedDocs);
  };

  const ONE_MB_CHUNK = 1048576;
  const effectiveUploadChunkSize = uploadChunkSize || ONE_MB_CHUNK;

  return (
    <div className="col-12 col-sm-12">
      <FileUpload
        defaultMessage="Drop withholding documents here in bmp, gif, jpg, png, tif, doc, docx, xls, xlsx, msg, pdf or zip format."
        postUrl={ ApiService.getFileUploadUrl() }
        accessTokenName={ ApiService.getAccessTokenName() }
        acceptedFiles="application/pdf,.jpg,.png,.bmp,.msg,.doc,.docx,.jpeg,.tiff,.gif,.tif,.xls,.xlsx,.zip"
        maxFilesize={ maxWhsFileSize }
        timeout={ files.uploadTimeout }
        docCategory="WithholdingStatementDocument"
        docType="WithholdingStatementDocument"
        uploadChunkSize={ effectiveUploadChunkSize }
        removeFileAfterUpload
        onFileSending={ () => onFileSending() }
        onFileUploadCancel={ file => onFileUploadCancel(file) }
        onFileUploadSuccess={ (file, response) => onFileUploadSuccess(file, response) }
        onFileUploadError={ (file, error) => onFileUploadError(file, error) }
      />
      <br />
      <div className="form-group">
        <div className="col-12">
          <table className="table table-striped table-hover">
            <thead>
              <tr><th colSpan="2">Documents Uploaded</th></tr>
            </thead>
            <tbody>
              { uploadedDocs != null && uploadedDocs.map(doc => doc != null && <tr key={ doc.id }>
                <td className="col-11 uploaded-filename-td">{ `${ doc.fileName }` }</td>
                <td className="col-1 text-right">
                  <button
                    className="btn btn-sm btn-danger"
                    type="button"
                    title="Delete document"
                    disabled={ isSubmitting }
                    onClick={ () => onDeleteUploadedDocument(doc) }
                    id={ `btn-delete-uploaded-document_${ doc.id }` }
                  >
                    <span className="icon icon-delete" />
                  </button>
                </td>
              </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <button
        type="button"
        id="dummy-add-form-btn"
        className="hide"
        onClick={ e => onFormSubmit(e) }
      >Submit</button>
    </div>
  );
};

UploadWhsDocuments.propTypes = {
  setDisableConfirm: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
};

UploadWhsDocuments.defaultProps = {
  isSubmitting: false
};

export default UploadWhsDocuments;
